<template>
  <div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <div v-if="draft">
      <div class="alert alert-info">
        Pastikan data yang sudah anda isi adalah data yang benar. Jika anda menekan tombol verifikasi , maka data tidak dapat diubah kembali. <strong>{{messages}}</strong>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-3">
            <table border="1" width="100%">
              <tr>
                <td align="center" style="padding: 10px">
                <img :src="`${base}storage/foto/${draft.nomor_pendaftar}.${draft.data_diri_pendaftar.ext_foto}`" height="200px" style="margin-right: 15px">
                </td>
              </tr>
              <tr>
              <td  align="center" style="padding-top: 10px"><h5 style="margin-left: 15px">{{ draft.penawaran_jalur.jalur.jalur_masuk }} Gelombang {{ draft.gelombang[0].nama }} - {{ draft.pilihan_jurusan[0].kelas_jalur.kelas.nama_kelas }}</h5></td>
              </tr>
              <tr>
                <td valign="top" style="padding-top: 10px; padding-bottom: 5px; padding-left: 15px" height="100px">
                  <table v-for="(jurusan, i) in draft.pilihan_jurusan" :key="i" width="100%">
                      <td width="30%">Pilihan {{ ++i }}</td>
                    <td width="70%"> : {{ jurusan.program_studi.nama_prodi }}</td>
                  </table>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-4">
            <table width="100%" style="margin-top: 15px">
              <td width="30%">Nama</td>
              <td width="70%"> : {{ draft.data_diri_pendaftar.nama_lengkap }}, {{ draft.data_diri_pendaftar.gelar_belakang }}</td>
            </table>
            <div v-if="draft.data_riwayat_pendidikan_s2 != null">
              <table width="100%">
                <td width="30%">Lulusan</td>
                <td width="70%"> : {{ draft.data_riwayat_pendidikan_s2.pendidikan.nama_pendidikan }}</td>
              </table>
              <table width="100%">
                <td width="30%">Nama PT</td>
                <td width="70%"> : {{ draft.data_riwayat_pendidikan_s2.nama_pt }}</td>
              </table>
              <table width="100%">
                <td width="30%">Tahun</td>
                <td width="70%"> : {{ draft.data_riwayat_pendidikan_s2.tahun_ijazah }}</td>
              </table>
              <table width="100%">
                <td width="30%">IPK</td>
                <td width="70%"> : {{ draft.data_riwayat_pendidikan_s2.ipk }}</td>
              </table>
            </div>
            <div v-if="draft.pendidikan_terakhir != null">
              <table width="100%">
                <td width="30%">Sekolah</td>
                <td width="70%"> : {{ draft.pendidikan_terakhir.nama_sekolah }}</td>
              </table>
              <table width="100%">
                <td width="30%">Jurusan</td>
                <td width="70%"> : {{ draft.pendidikan_terakhir.jurusan_sekolah.nama_jurusan_sekolah }}</td>
              </table>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <h4>DATA DIRI PESERTA</h4>
      <div style="margin-top: 40px">
        <table width="100%">
          <td width="30%">Nama</td>
          <td width="70%"> : {{ draft.data_diri_pendaftar.nama_lengkap }}, {{ draft.data_diri_pendaftar.gelar_belakang }}</td>
        </table>
        <table width="100%">
          <td width="30%">Alamat</td>
          <td width="70%"> : {{ draft.data_diri_pendaftar.alamat_lengkap }}</td>
        </table>
        <table width="100%">
          <td width="30%">Tanggal Lahir</td>
          <td width="70%"> : {{ draft.data_diri_pendaftar.tgl_lahir }}</td>
        </table>
        <table width="100%">
          <td width="30%">Agama</td>
          <td v-if="draft.data_diri_pendaftar.agama != null" width="70%"> : {{ draft.data_diri_pendaftar.agama.nama_agama }}</td>
          <td v-else width="70%"> : -</td>
        </table>
        <table width="100%">
          <td width="30%">Jenis Kelamin</td>
          <td width="70%"> : {{ draft.data_diri_pendaftar.jenis_kelamin }}</td>
        </table>
        <table width="100%">
          <td width="30%">Telp</td>
          <td width="70%"> : {{ draft.data_diri_pendaftar.telp }}</td>
        </table>
        <table width="100%">
          <td width="30%">HP</td>
          <td width="70%"> : {{ draft.data_diri_pendaftar.nohp }}</td>
        </table>
        <table width="100%">
          <td width="30%">Kode Pos</td>
          <td width="70%"> : {{ draft.data_diri_pendaftar.kode_pos }}</td>
        </table>
        <table width="100%">
          <td width="30%">Email</td>
          <td width="70%"> : {{ draft.data_diri_pendaftar.email }}</td>
        </table>
        <table width="100%">
          <td width="30%">Warga Negara</td>
          <td v-if="draft.data_diri_pendaftar.negara != null" width="70%"> : {{ draft.data_diri_pendaftar.negara.nama_negara }}</td>
          <td v-else width="70%"> : -</td>
        </table>
        <table v-if="draft.data_orang_tua != null" width="100%">
          <td width="30%">Nama Ayah</td>
          <td width="70%"> : {{ draft.data_orang_tua.nama_lengkap_ayah }}</td>
        </table>
        <table v-if="draft.data_orang_tua != null" width="100%">
          <td width="30%">Nama Ibu</td>
          <td width="70%"> : {{ draft.data_orang_tua.nama_lengkap_ibu }}</td>
        </table>
        <table v-if="draft.kesehatan_mahasiswa != null" width="100%">
          <td width="30%">Riwayat Penyakit</td>
          <td width="70%"> : {{ draft.kesehatan_mahasiswa.riwayat_penyakit }}</td>
        </table>
        <table width="100%">
          <td width="30%">Kemampuan Berbeda</td>
          <td v-if="draft.kemampuan_berbeda.length > 0" width="70%"> : {{ draft.kemampuan_berbeda[0].kesehatan.kondisi_kesehatan }}</td>
          <td v-else width="70%"> : Normal</td>
        </table>
        <div v-if="draft.data_riwayat_pendidikan_s2 != null">
          <table width="100%">
            <td width="30%">Lulusan</td>
            <td width="70%"> : {{ draft.data_riwayat_pendidikan_s2.pendidikan.nama_pendidikan }}</td>
          </table>
          <table width="100%">
            <td width="30%">Nama PT</td>
            <td width="70%"> : {{ draft.data_riwayat_pendidikan_s2.nama_pt }}</td>
          </table>
          <table width="100%">
            <td width="30%">Tahun</td>
            <td width="70%"> : {{ draft.data_riwayat_pendidikan_s2.tahun_ijazah }}</td>
          </table>
          <table width="100%">
            <td width="30%">IPK</td>
            <td width="70%"> : {{ draft.data_riwayat_pendidikan_s2.ipk }}</td>
          </table>
        </div>
        <div v-if="draft.pendidikan_terakhir != null">
          <table width="100%">
            <td width="30%">Sekolah</td>
            <td width="70%"> : {{ draft.pendidikan_terakhir.nama_sekolah }}</td>
          </table>
          <table width="100%">
            <td width="30%">Jurusan</td>
            <td width="70%"> : {{ draft.pendidikan_terakhir.jurusan_sekolah.nama_jurusan_sekolah }}</td>
          </table>
        </div>
      </div>
      <hr>
      <div style="padding: 20px 0px">
        <div style="margin-bottom: 10px"><strong>Jadwal Ujian</strong> :</div>
        <div v-for="(jadwal, i) in draft.detail_jadwal" :key="i">{{ ++i }}. {{ jadwal.tanggal_indo }} {{ jadwal.jam_mulai }} - {{ jadwal.jam_selesai }} {{ jadwal.jenis_tes.nama_tes }}</div>
      </div>
      <!-- <div><strong>Catatan</strong> :</div> -->
      <ul style="padding-left: 20px; margin-top: 10px">
        <li v-for="(catatan, i) in draft.catatan" :key="i">{{ catatan.note }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import { base } from '@/api/data'

export default {
  data () {
    return {
      loading: false,
      draft: null
    }
  },
  computed: {
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    base () {
      return base
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(23).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    initData () {
      this.loading = true
      if (process.env.NODE_ENV !== 'test') {
        api.get(`/v2/draft_kartu/${this.nomorPendaftar}`)
          .then(response => {
            this.draft = response.data.data
            this.loading = false
          })
      } else {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataVerifikasi.vue